module.exports = __webpack_public_path__ + "static/img/SB.003beb2b.svg";